import Container from "./Container"
import Button from "./Button"
import useUser from "@/hooks/useUser"

const CTA = () => {
  const { isAuthenticated } = useUser()

  return (
    <Container tag="section" className="py-16 sm:py-24">
      <Container className="flex flex-col items-center justify-center rounded-3xl bg-gray-900 py-10 sm:py-16">
        <h2 className="text-center text-3xl font-bold text-balance text-white sm:text-4xl lg:text-5xl">
          Get ChessDrop today
        </h2>
        <p className="mt-4 text-center text-lg text-gray-200 sm:mt-5 sm:text-xl">
          Works on your desktop and mobile device.
        </p>

        {isAuthenticated ? (
          <Button
            href="/games"
            className="mx-auto mt-8 w-full sm:w-auto"
            size="xl"
          >
            Dashboard
          </Button>
        ) : (
          <div className="mt-8 flex flex-col items-center gap-4 sm:flex-row">
            <Button
              href="/try"
              className="w-full sm:w-auto"
              size="xl"
            >
              Try it!
            </Button>
            <Button
              href="/signup"
              className="w-full sm:w-auto"
              size="xl"
              style="secondary"
            >
              Sign up
            </Button>
          </div>
        )}
      </Container>
    </Container>
  )
}

export default CTA
